"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.mapStateToProps = exports.AnnouncementStatusLight = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _StatusLight = _interopRequireDefault(require("@react/react-spectrum/StatusLight"));

var _reactRedux = require("react-redux");

var AnnouncementSelectors = _interopRequireWildcard(require("../../store/reducers/AnnouncementReducer"));

/*************************************************************************
 ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/
var AnnouncementStatusLight =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AnnouncementStatusLight, _Component);

  function AnnouncementStatusLight() {
    (0, _classCallCheck2.default)(this, AnnouncementStatusLight);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AnnouncementStatusLight).apply(this, arguments));
  }

  (0, _createClass2.default)(AnnouncementStatusLight, [{
    key: "render",

    /**
     * Renders the Status Light
     *
     * @return {ReactElement} markup representing the tabs
     */
    value: function render() {
      if (this.props.hasUnseenAnnouncements) {
        return _react.default.createElement(_StatusLight.default, {
          variant: "active",
          className: "pulse-announcements-tab-statuslight"
        });
      }

      return null;
    }
  }]);
  return AnnouncementStatusLight;
}(_react.Component);
/**
 * mapping to store
 * @param {JSONObject} state
 */


exports.AnnouncementStatusLight = AnnouncementStatusLight;

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasUnseenAnnouncements: AnnouncementSelectors.hasUnseenAnnouncements(state)
  };
};

exports.mapStateToProps = mapStateToProps;

var _default = (0, _reactRedux.connect)(mapStateToProps)(AnnouncementStatusLight);

exports.default = _default;